module.exports = __webpack_public_path__ + "img/logo_v2.1ff9fd4b.svg";